{
    "app": {
        "sidebar": {
            "collapse": "Menu inklappen",
            "expand": "Menu uitklappen"
        },
        "brand": {
            "name": "gaia ecologie"
        },
        "dashboard": {
            "title": "Dashboard",
            "theme": "Schakel over naar {{theme}} thema"
        },
        "errorScreen": {
            "title": "Er is iets misgegaan"
        },
        "gaiaFilterOptions": {
            "title": "Filters"
        },
        "gaiaFilterHeader": {
            "drawerTitle": "Filter"
        },
        "gaiaGridOverlay": {
            "noResults": "Geen resultaten"
        },
        "gaiaConfirmCloseDialog": {
            "title": "Niet-opgeslagen wijzigingen",
            "description": "Formuliergegevens gaan verloren. Doorgaan?",
            "cancel": "Annuleren",
            "proceed": "Doorgaan"
        },
        "gaiaConfirmDialog": {
            "defaultTitle": "Waarschuwing",
            "defaultDescription": "Deze actie kan niet ongedaan worden gemaakt. Doorgaan?",
            "cancel": "Annuleren",
            "proceed": "Doorgaan"
        },
        "gaiaDialog": {
            "cancel": "Annuleren",
            "save": "Opslaan"
        },
        "gaiaColorPicker": {
            "btnPickColor": "Kies kleur",
            "btnClose": "Sluiten"
        },
        "workerJobStatus": {
            "working": "Bezig...",
            "success": "Voltooid",
            "failed": "Er is iets misgegaan"
        },
        "notification": {
            "notifications": "Meldingen",
            "noNotifications": "Geen nieuwe meldingen beschikbaar op dit moment"
        },
        "dashboardComponents": {
            "mainDashboardScreen": {
                "title": "Welkom {{firstName}}"
            },
            "dashboardFieldworkerOnboarding": {
                "title": "Onboarding",
                "description": "Vul de volgende gegevens in om te beginnen met werken"
            },
            "dashboardFieldworkerAvailabilityRequired": {
                "title": "Welkom {{firstName}}",
                "description": "Vul je algemene beschikbaarheid in om aan de slag te gaan. Geef daarnaast aan hoeveel diensten je maximaal per week wilt uitvoeren. Je kan vrije dagen op een later moment via je kalender aanvragen.",
                "btnAvailability": "Vul je beschikbaarheid nu in"
            },
            "dashboardFieldworkerNextDays": {
                "title": "Veldwerker inzichten",
                "description": "Overzicht voor de komende {{numberOfDays}} dagen",
                "availability": "Beschikbaarheid",
                "updateAvailability": "Bijwerken"
            },
            "dashboardFieldworkerNextShift": {
                "nextShift": "Komende dienst",
                "btnGoToShifts": "Roosters",
                "noUpcomingShift": "Geen komende diensten"
            },
            "dashboardFieldworkerLatestFeedback": {
                "latestFeedback": "Laatste feedback",
                "btnGoToFeedback": "Feedback",
                "noRecentFeedback": "Geen recente feedback"
            },
            "dashboardClientUserClientList": {
                "clients": "Klanten",
                "allProjectsBtn": "Alle Projecten"
            },
            "dashboardProjectUserProjectList": {
                "projects": "Projecten",
                "startDate": "Startdatum",
                "mapViewBtn": "Openen"
            }
        },
        "functionCard": {
            "mediaLabel": "Media"
        }
    },
    "admin": {
        "adminMenu": {
            "headerAdmin": "Beheer",
            "itemClients": "Klanten",
            "itemUsers": "Gebruikers",
            "itemLibrary": "Bibliotheek",
            "itemPayments": "Betalingen",
            "itemSettings": "Instellingen"
        }
    },
    "user": {
        "userCreateScreen": {
            "title": "Nieuwe gebruiker"
        },
        "userUpdateScreen": {
            "fieldworkerTitle": "Informatie veldwerker",
            "fieldworkerCreate": "Maak veldwerker",
            "roleTitle": "Rol",
            "researchRequirementsTitle": "Onderzoekseisen",
            "btnViewAvailability": "Bekijk beschikbaarheid",
            "btnViewShifts": "Bekijk diensten",
            "passwordTitle": "Wachtwoord",
            "title": "Gebruiker"
        },
        "userCourseList": {
            "colName": "Naam",
            "colIsCompleted": "Voltooid",
            "colDelete": "Verwijderen"
        },
        "userListScreen": {
            "title": "Gebruikers",
            "colName": "Naam",
            "colEmail": "E-mail",
            "colPhone": "Telefoon",
            "colRole": "Rol",
            "colTimeoff": "Verlof",
            "tooltipNewUser": "Nieuwe gebruiker toevoegen",
            "tooltipImportUsers": "Gebruikers importeren",
            "filterSearch": "Zoeken",
            "filterCourse": "Cursus",
            "filterTransportation": "Vervoer",
            "filterRole": "Rol"
        },
        "userImportScreen": {
            "title": "Gebruikers importeren"
        },
        "userForm": {
            "labelFirstname": "Voornaam",
            "labelLastname": "Achternaam",
            "labelPhone": "Telefoonnummer",
            "labelPhoneCountry": "Telefoonnummer Land",
            "sectionContact": "Contactgegevens",
            "labelEmail": "E-mail",
            "labelPassword": "Wachtwoord",
            "labelRole": "Rol",
            "sectionFieldworkerDetails": "Details veldwerker",
            "btnSubmit": "Opslaan",
            "btnLogout": "Uitloggen",
            "labelAddress": "Adres",
            "labelAddressNoOptions": "Vul uw straat en huisnummer in",
            "labelHaveACar": "Heeft u een auto?",
            "labelCurrentPassword": "Huidig wachtwoord",
            "labelNewPassword": "Nieuw wachtwoord",
            "labelConfirmNewPassword": "Bevestig nieuw wachtwoord",
            "labelExternalReference": "External Reference ID",
            "setPassword": "Stel wachtwoord in",
            "sectionPassword": "Wachtwoord",
            "language": "Taal"
        },
        "userCreateForm": {
            "labelFirstname": "Voornaam",
            "labelLastname": "Achternaam",
            "sectionContact": "Contactgegevens",
            "labelPhone": "Telefoonnummer",
            "labelEmail": "E-mail",
            "labelRole": "Rol",
            "sectionPassword": "Wachtwoord instellen",
            "labelPassword": "Wachtwoord",
            "btnSubmit": "Opslaan",
            "sendInvite": "Stuur uitnodiging",
            "emailInvalid": "Ongeldig e-mailadres",
            "emailRequired": "E-mail is verplicht",
            "errorConfirmPasswordMismatch": "Wachtwoorden komen niet overeen",
            "labelConfirmPassword": "Bevestig wachtwoord"
        },
        "fieldworkerForm": {
            "title": "Veldwerker",
            "create": "Maak veldwerker",
            "labelAddress": "Adres",
            "labelAddressNoOptions": "Vul uw straat en huisnummer in",
            "labelHasOwnTransport": "Eigen vervoer",
            "labelIsMywheelsUser": "MyWheels-gebruiker",
            "labelHasFinishedOnboarding": "Onboarding voltooid",
            "hasConfirmedAvailability": "Bevestigde beschikbaarheid",
            "labelIsPayable": "Betaalbaar",
            "labelIsActive": "Actieve veldwerker",
            "labelAdmin": "Admin",
            "btnSubmit": "Opslaan"
        },
        "fieldworkerOnboardingForm": {
            "labelAddress": "Adres",
            "labelHaveACar": "Heeft u een auto?",
            "labelHasADriversLicense": "Heeft u een rijbewijs?",
            "label21yearsOrOlder": "Bent u 21 jaar of ouder?",
            "labelAddressNoOptions": "Vul uw straat en huisnummer in",
            "labelHasDriversLicenseMoreThan1Year": "Heeft u langer dan 1 jaar een rijbewijs?",
            "btnSubmit": "Opslaan"
        },
        "fieldWorkerCreateAccount": {
            "applyForFieldWorker": "Aanmelden voor veldwerk",
            "createFieldWorkerAccount": "Maak een veldwerkeraccount aan om te beginnen",
            "firstNameLabel": "Voornaam",
            "surnameLabel": "Achternaam",
            "emailLabel": "E-mail",
            "phoneNumberLabel": "Telefoonnummer",
            "passwordLabel": "Wachtwoord",
            "submitButtonLabel": "Begin nu",
            "consentText": "Ik ga akkoord met de <1>Servicevoorwaarden</1> en <2>Privacybeleid</2>.",
            "errors": {
                "firstNameRequired": "Voornaam is verplicht",
                "surnameRequired": "Achternaam is verplicht",
                "emailRequired": "E-mail is verplicht",
                "emailInvalid": "Ongeldig e-mailadres",
                "phoneRequired": "Telefoonnummer is verplicht",
                "passwordRequired": "Wachtwoord is verplicht",
                "passwordMinLength": "Wachtwoord moet minstens 8 tekens lang zijn",
                "consentRequired": "U moet akkoord gaan met de voorwaarden om door te gaan."
            }
        },
        "profilePhotoUploader": {
            "title": "Selecteer profielfoto",
            "labelChangePhoto": "Foto wijzigen",
            "labelUploadPhoto": "Foto uploaden",
            "labelAllowedFormats": "Toegestane formaten: JPG, PNG (Max grootte: 5MB)"
        },
        "userImportFeedback": {
            "users": "Gebruikers",
            "title": "Gebruikers importeren",
            "newFieldworkers": "Nieuwe veldwerkers: {{newFieldworkers}} gebruikers.",
            "imported": "Geïmporteerd: {{success}} / {{total}} gebruikers.",
            "couldNotImport": "{{usersNotImported}} gebruikers konden niet worden geïmporteerd."
        }
    },
    "auth": {
        "loginForm": {
            "title": "Inloggen",
            "emailLabel": "E-mail",
            "passwordLabel": "Wachtwoord",
            "btnLogin": "Inloggen",
            "btnForgotPassword": "Wachtwoord vergeten?",
            "errorUsernameOrPassword": "Ongeldige gebruikersnaam of wachtwoord"
        },
        "resetPasswordScreen": {
            "title": "Wachtwoord resetten"
        },
        "createPasswordScreen": {
            "title": "Wachtwoord aanmaken",
            "description": "Voer een nieuw wachtwoord in voor je account",
            "btnCreatePassword": "Wachtwoord aanmaken"
        },
        "resetPasswordForm": {
            "labelEmail": "E-mail",
            "labelNewPassword": "Nieuw wachtwoord",
            "labelNewPasswordRequired": "Nieuw wachtwoord is verplicht",
            "helperTextNewPassword": "Minimaal 8 tekens, minstens 1 nummer en 1 speciaal teken (@, #, $, %, &, !)",
            "labelConfirmNewPassword": "Bevestig nieuw wachtwoord",
            "labelConfirmNewPasswordRequired": "Bevestig dat een nieuw wachtwoord vereist is",
            "labelEmailRequired": "E-mail is verplicht",
            "btnSubmit": "Verzenden",
            "btnBack": "Terug",
            "success": "Een link om uw wachtwoord te resetten is naar uw e-mailadres verzonden: {{email}}",
            "resetPassword": "Wachtwoord opnieuw instellen"
        },
        "login": {
            "btnNewClient": "New Client",
            "btnStartProject": "Start project",
            "btnNewWorker": "New Fieldworker",
            "btnApplyNow": "Apply now"
        }
    },
    "client": {
        "clientMenu": {
            "itemDashboard": "Dashboard",
            "projects": "Projecten",
            "planned": "Planning",
            "invoices": "Facturen",
            "protocolTemplates": "Protocoltemplates",
            "users": "Gebruikers",
            "backToClients": "Terug naar klanten",
            "settings": "Instellingen",
            "projectExport": "Exporteren"
        },
        "clientListScreen": {
            "title": "Klanten",
            "colName": "Naam",
            "colType": "Type",
            "filterName": "Naam"
        },
        "clientCreateScreen": {
            "title": "Nieuwe klant",
            "btnSubmit": "Aanmaken"
        },
        "clientUpdateScreen": {
            "title": "Klant bewerken",
            "btnSubmit": "Bijwerken"
        },
        "clientForm": {
            "name": "Naam",
            "type": "Type",
            "typeValue": {
                "Private": "Particulier",
                "Organisation": "Organisatie"
            },
            "address": "Adres",
            "sectionContact": "Contactgegevens",
            "contactName": "Contactpersoon",
            "contactEmail": "E-mail",
            "contactPhone": "Telefoonnummer",
            "allLayersVisible": "Alle nieuwe lagen zichtbaar"
        }
    },
    "invoice": {
        "list": {
            "title": "Facturatieperiodes",
            "table": {
                "year": "Jaar",
                "month": "Maand",
                "createdAt": "Toegevoegd",
                "amount": "Bedrag",
                "numberOfRecords": "Aantal bezoeken",
                "actions": {
                    "view": "Bekijk",
                    "create": "Maak"
                }
            }
        },
        "detail": {
            "emptyPage": "Geen factuurinformatie beschikbaar",
            "invoiceForPeriod": "Factuur voor {{period}}",
            "totalCostPeriod": "Totaalbedrag voor de periode",
            "project": "Project",
            "amount": "Bedrag",
            "btnDownloadCsv": "Download CSV",
            "visit": {
                "completedVisits": "Voltooide bezoeken",
                "date": "Datum",
                "protocolName": "Protocol",
                "visitNumber": "#",
                "travelTime": "Reistijd",
                "travelDistance": "Afstand (retour)",
                "travelCostPerKm": "Kosten/km (retour)",
                "requiredFieldworkers": "Werkers",
                "pricePerHour": "Tarief/u",
                "duration": "Tijd",
                "cost": "Totaal"
            },
            "title": "Factuur"
        }
    },
    "project": {
        "projectMenu": {
            "itemDashboard": "Dashboard",
            "users": "Project gebruikers",
            "planning": "Planning",
            "projectExport": "Export",
            "deliverables": "Deliverables",
            "protocols": "Protocollen",
            "overview": "Overzicht",
            "mapView": "Kaartweergave",
            "settings": "Instellingen",
            "cost": "Kosten"
        },
        "projectListScreen": {
            "title": "Projecten",
            "colName": "Naam",
            "filterName": "Naam",
            "colStatus": "Status",
            "projectStatusValue": {
                "open": "Open",
                "confirmed": "Bevestigd",
                "cancelled": "Geannuleerd",
                "completed": "Voltooid"
            }
        },
        "ProjectStatusSelect": {
            "labelStatus": "Status",
            "projectStatusValue": {
                "open": "Open",
                "confirmed": "Bevestigd",
                "cancelled": "Geannuleerd",
                "completed": "Voltooid"
            }
        },
        "projectCreateScreen": {
            "title": "Nieuw project",
            "btnSubmit": "Aanmaken"
        },
        "projectUpdateScreen": {
            "title": "Project bewerken",
            "btnSubmit": "Bijwerken",
            "btnDelete": "Verwijder Project",
            "dangertitle": "Gevaarzone"
        },
        "projectForm": {
            "labelName": "Naam",
            "sectionContact": "Contactgegevens",
            "labelContactName": "Contactpersoon",
            "labelContactEmail": "E-mail",
            "labelContactPhone": "Telefoonnummer",
            "sectionStatus": "Status informatie",
            "labelProjectStatus": "Project status",
            "labelIsSpeciesManagementPlan": "Soortenmanagementplan",
            "labelShowAllObservationsToClientUser": "Toon alle observaties aan klant",
            "projectStatusValue": {
                "open": "Open",
                "confirmed": "Bevestigd",
                "cancelled": "Geannuleerd",
                "completed": "Voltooid"
            },
            "labelStartDate": "Startdatum",
            "sectionFinancials": "Financieel",
            "labelTravelAllowanceKms": "Voorrijdafstand (retour, km)",
            "labelTravelAllowancePerKmCents": "Reiskostenvergoeding per km (EUR centen)",
            "labelTravelAllowanceTimeInSeconds": "Voorrijdtijd (retour)",
            "selectTravelAllowanceTimeInSeconds": {
                "30-minutes": "30 minuten",
                "45-minutes": "45 minuten",
                "1-hour": "1 uur",
                "1.5-hours": "1,5 uur",
                "2-hours": "2 uur",
                "2.5-hours": "2,5 uur",
                "3-hours": "3 uur"
            },
            "validationMinimum0": "Deze waarde moet minimaal 0 zijn"
        },
        "projectVisitScreen": {
            "warningIncompleteObservationsTitle": "Rapport bevat incomplete observaties",
            "warningIncompleteObservationsDescription": "Incomplete observaties worden niet meegenomen in de resultaten. Doorgaan?",
            "labelNoSubmittedReports": "Er zijn nog geen rapporten ingediend door de veldwerkers.",
            "labelNoPlannedShifts": "Er is nog geen shift gepland.",
            "visitNumber": "{{protocolName}}, Bezoek: {{visitNumber}}",
            "btnContinueAndApproveAll": "Doorgaan en alle resterende goedkeuren",
            "btnContinue": "Doorgaan",
            "btnRejectAll": "Alles afkeuren en opnieuw inplannen",
            "labelApproveAllTitle": "Alles goedkeuren: {{items}}",
            "labelApproveAllDescription": "Weet je zeker dat je alle {{items}} wilt goedkeuren en wilt doorgaan naar de volgende stap?",
            "summarySection": {
                "visitConditions": "Weersomstandigheden",
                "summary": "Samenvatting",
                "generateSummary": "Samenvatting genereren",
                "confirmGenerateSummaryTitle": "Samenvatting opnieuw genereren",
                "confirmGenerateSummaryDescription": "Weet je zeker dat je de samenvatting opnieuw wilt genereren? De bestaande tekst wordt overschreven.",
                "significantObservations": "Conclusies",
                "restObservations": "Observaties",
                "observationTable": {
                    "species": "Soort",
                    "where": "Waar",
                    "address": "Adres",
                    "stayPlace": "Verblijfplaats"
                },
                "saveSummaryText": "Samenvatting opslaan & bezoek goedkeuren"
            }
        },
        "overviewScreen": {
            "title": "Project Overzicht",
            "emptyStatistic": "Geen gegevens gevonden",
            "visitProgress": {
                "title": "Bezoek Voortgang",
                "subtitle": "{{completed}} van {{total}} bezoeken"
            },
            "activeProtocols": {
                "title": "Actieve Protocollen",
                "subtitle": "{{active}}/{{total}} protocollen actief"
            },
            "areas": {
                "title": "Gebieden",
                "subtitle": "Onderzoekslocaties"
            },
            "functionsFound": {
                "title": "Functies Gevonden",
                "subtitle": "{{recent}} nieuwe functies"
            },
            "reports": {
                "title": "Rapporten",
                "subtitle": "Goedgekeurde bezoeken"
            },
            "visitStatusDistribution": {
                "title": "Bezoek Status",
                "status": "Status",
                "count": "Aantal",
                "percentage": "Percentage",
                "statusValue": {
                    "approved": "Goedgekeurd",
                    "ecoTeamReview": "Eco Team Review",
                    "planned": "Gepland",
                    "unplanned": "Ongepland"
                },
                "link": "Alle bezoeken"
            },
            "activeProtocolOverview": {
                "title": "Actieve Protocol Status",
                "stats": {
                    "numberOfAreas_one": "{{count}} gebied",
                    "numberOfAreas_other": "{{count}} gebieden",
                    "numberOfPlannedVisits_one": "{{count}} bezoek",
                    "numberOfPlannedVisits_other": "{{count}} bezoeken",
                    "numberOfCompletedVisits_one": "{{count}} bezoek afgerond",
                    "numberOfCompletedVisits_other": "{{count}} bezoeken afgerond"
                },
                "link": "Alle protocollen"
            },
            "upcomingVisits": {
                "title": "Aankomende Geplande Bezoeken",
                "link": "Geplande bezoeken"
            },
            "recentVisits": {
                "title": "Recent Goedgekeurde Bezoeken",
                "link": "Goedgekeurde bezoeken"
            }
        },
        "deliverablesScreen": {
            "labelResearchType": "Onderzoekstype",
            "labelPlannerAreas": "Gebieden",
            "map": {
                "legend": {
                    "title": "Legenda",
                    "species": "Soorten",
                    "functions": "Functies",
                    "areas": "Gebieden",
                    "plannerArea": "Planningsgebied"
                }
            },
            "copyBtn": "Kopieeren",
            "noData": "Geen gegevens gevonden"
        },
        "projectVisitInfo": {
            "labelVisitNumber": "Bezoeknummer: {{visitNumber}}",
            "labelStartAt": "Start: {{startAt}}",
            "labelEndAt": "Eind: {{endAt}}",
            "labelPlannedDuration": "Geplande duur: {{plannedDuration}}",
            "title": "Visit",
            "btnOpenPlanner": "Open in planner",
            "requiredWorkers": "Benodigde werkers"
        },
        "projectVisitStatusControl": {
            "title": "Status",
            "visitStatus": {
                "unplanned": "Unplanned",
                "draft": "Concept",
                "planned": "Planned",
                "awaitingReports": "Awaiting reports",
                "awaitingApproval": "Awaiting approval",
                "approved": "Approved",
                "rejected": "Rejected"
            }
        },
        "projectVisitReportStatus": {
            "labelReports": "{{handledReports}}/{{totalReports}} Reports",
            "visitStatus": {
                "unplanned": "Unplanned",
                "draft": "Concept",
                "planned": "Planned",
                "awaitingReports": "Awaiting reports",
                "awaitingApproval": "Awaiting approval",
                "approved": "Approved",
                "rejected": "Rejected"
            }
        },
        "generateReportSummaryButton": {
            "btnGenerateReportSummary": "Genereer samenvatting"
        },
        "projectVisitWorkerReport": {
            "labelStartedAt": "Gestart om",
            "labelStoppedAt": "Gestopt om",
            "labelDayReport": "Dagrapport",
            "labelAwaitingReport": "Wacht op indiening van het werkersrapport.",
            "visitNumber": "Bezoek {{visitNumber}}",
            "btnSave": "Opslaan",
            "titleStartForm": "Startformulier",
            "titleNotes": "Opmerkingen",
            "noNotes": "Geen opmerkingen toegevoegd.",
            "titleSubmittedForm": "Eindformulier",
            "report": "Rapport",
            "precipitation": "Neerslag",
            "temp": "Temperatuur (°C)",
            "cloudiness": "Bewolking %",
            "wind": "Wind (bft)",
            "wind-direction": "Windrichting",
            "btnClose": "Sluiten",
            "labelDuration": "Totale duur: {{duration}}",
            "labelIsOutOfProtocol": "Buiten protocol",
            "labelOutOfProtocolNotes": "Notities buiten protocol",
            "labelStartStopLong": "{{date}} van {{startTime}} tot {{endTime}} ({{duration}})",
            "rateReport": "Beoordeel het rapport",
            "createEmptyReport": "Leeg rapport maken"
        },
        "readyForPaymentForm": {
            "labelReadyForPayment": "Klaar voor betaling"
        },
        "projectVisitShiftReport": {
            "labelStartAt": "Start: {{startAt}}",
            "labelEndAt": "Einde: {{endAt}}",
            "labelShiftId": "Shift-ID: {{shiftId}}"
        },
        "deviationFromProtocol": {
            "title": "Afgeweken van protocol",
            "btnSave": "Opslaan",
            "labelDeviatedFromProtocolNotes": "Toelichting op afwijking",
            "labelDeviatedFromProtocolWarning": "Geef een toelichting op de afwijking"
        },
        "projectVisitFullReport": {
            "labelSummary": "Samenvatting",
            "labelEditSummary": "Bewerk samenvatting",
            "labelSummaryNotYetAvailable": "Samenvatting is nog niet beschikbaar.",
            "btnGenerateReportSummary": "Genereer samenvatting",
            "btnEdit": "Bewerken",
            "btnSave": "Opslaan",
            "btnCancel": "Annuleren"
        },
        "observationMediaDisplay": {
            "labelMedia": "Media"
        },
        "observationPanel": {
            "labelObservations": "Observaties"
        },
        "visitStatusActionButton": {
            "labelApprove": "Goedkeuren",
            "labelReject": "Afkeuren",
            "labelRevertApproval": "Goedkeuring intrekken"
        },
        "visitList": {
            "noVisitName": "Bezoek",
            "observations": "Observaties",
            "conclusions": "Resultaten",
            "noObservations": "Geen observaties",
            "noConclusions": "Geen resultaten",
            "linkedObservations": "Gekoppelde observaties",
            "animalsCount": "Aantal dieren"
        },
        "feedbackForm": {
            "title": "Feedback op rapport",
            "feedbackRating": "Feedback",
            "feedbackComment": "Opmerking"
        },
        "projectReviewVisitV2": {
            "backToOverviewBtn": "Terug naar alle bezoeken",
            "visitInfoCard": {
                "requiredWorkers": "Benodigde werkers",
                "plannedDuration": "Geplande duur",
                "start": "Min. Startijd",
                "end": "Max. Eindtijd",
                "sunriseTime": "Zonsopgang Tijd",
                "sunsetTime": "Zonsondergang Tijd",
                "btnOpenPlanner": "Openen in Planner"
            },
            "overview": {
                "hasStagedChanges": "Dit bezoek heeft openstaande wijzigingen in de planner.",
                "navigationItems": {
                    "time": {
                        "label": "Tijd",
                        "caption": "Alle rapporten zijn automatisch gevalideerd"
                    },
                    "weather": {
                        "label": "Weer",
                        "caption": "Alle rapporten zijn automatisch gevalideerd"
                    },
                    "teamReports": {
                        "label": "Teamrapporten",
                        "caption": "Moet worden beoordeeld"
                    },
                    "functions": {
                        "label": "Functies",
                        "caption": "Geen items te beoordelen"
                    },
                    "observations": {
                        "label": "Observaties",
                        "caption": "Geen items te beoordelen"
                    }
                },
                "finalisePending": "Rond de bovenstaande items af.",
                "finaliseButton": "Rapport afronden",
                "approveDialog": {
                    "title": "Weet je zeker dat je dit bezoek wilt goedkeuren?",
                    "description": "Deze actie kan niet ongedaan worden gemaakt. Veldwerkers worden gemarkeerd als betaald en de bezoekresultaten worden zichtbaar voor de klant."
                }
            },
            "approvalAlert": {
                "approvedBy": "Dit bezoek is goedgekeurd door",
                "on": "op {{date}}.",
                "openFinalReport": "Open eindrapport"
            },
            "rejectionAlert": {
                "rejectedBy": "Dit bezoek is afgewezen door",
                "on": "op {{date}}.",
                "reasonLabel": "Reden voor afwijzing",
                "revertButton": "Afwijzing terugdraaien",
                "revertDialog": {
                    "title": "Afwijzing terugdraaien?",
                    "message": "Weet je zeker dat je de afwijzing wilt terugdraaien? Het bezoek keert terug naar de status 'wacht op goedkeuring'.",
                    "cancel": "Annuleren",
                    "confirm": "Afwijzing terugdraaien"
                }
            },
            "status": {
                "unplanned": {
                    "title": "Dit bezoek is nog niet gepland."
                },
                "planned": {
                    "title": "Dit bezoek is gepland.",
                    "scheduledFor": "Dit bezoek is gepland voor {{date}}."
                },
                "awaitingReport": {
                    "title": "Dit bezoek wacht op rapport.",
                    "description": "Dit bezoek vond plaats op {{date}}. Sommige gegevens ontbreken nog of wachten op indiening.",
                    "fieldworkersWithoutReportsLabel": "We wachten op rapporten van:"
                },
                "openInPlannerButton": "Openen in Planner"
            },
            "functionsRoute": {
                "title": "Functies",
                "functionDetailTitle": "Functie",
                "possibleFunctionObservationDetailTitle": "Mogelijke functie",
                "noFunctions": "Geen functies",
                "possibleFunctionsTab": "Mogelijke functies ({{ value }})",
                "createdFunctionsTab": "Gemaakte functies ({{ value }})"
            },
            "observationsRoute": {
                "title": "Observaties",
                "observationDetailTitle": "Observatie beoordelen",
                "bulkApproveDialog": {
                    "title": "Alle observaties Goedkeuren",
                    "description": "Weet u zeker dat u alle geldige observaties wilt goedkeuren?"
                },
                "bulkApproveButton": "Alle geldige observaties goedkeuren",
                "bulkApproveButtonLoading": "Goedkeuren...",
                "noObservations": "Geen observaties gevonden"
            },
            "teamReportsRoute": {
                "title": "Teamrapporten",
                "errorMsg": "Teamrapporten kunnen pas worden goedgekeurd nadat de start- en eindtijden van het bezoek zijn bevestigd, omdat de vergoeding van de veldmedewerker op basis van die tijden wordt berekend.",
                "labelNoReportsFound": "Geen rapporten gevonden.",
                "workerReport": {
                    "labelRateReport": "Beoordeel het rapport",
                    "labelFeedbackComment": "Opmerking",
                    "btnSave": "Opslaan",
                    "labelNotes": "Opmerkingen",
                    "notSubmitted": "Rapport nog niet ingediend",
                    "labelShiftWillBePaid": "Shift wordt betaald"
                },
                "approvalButton": {
                    "labelApprove": "Goedkeuren",
                    "labelRevertApproval": "Goedkeuring intrekken"
                }
            },
            "timeReportsRoute": {
                "title": "Tijdrapporten",
                "requiredWorkers": "Benodigde werkers",
                "start": "Min. Startijd",
                "end": "Max. Eindtijd",
                "plannedDuration": "Geplande duur",
                "noReportsFound": "Geen tijd rapporten gevonden.",
                "table": {
                    "fieldworker": "Veldwerker",
                    "start": "Start",
                    "end": "Eind",
                    "duration": "Duur",
                    "saveBtn": "Opslaan"
                }
            },
            "weatherReportsRoute": {
                "title": "Weerrapport",
                "temperatureRange": "Temperatuurbereik",
                "maxWindforce": "Max. Windkracht",
                "maxPrecipitation": "Max. Neerslag",
                "precipitationLevels": {
                    "dry": "Droog",
                    "mist": "Mist",
                    "drizzle": "Motregen",
                    "rain": "Regen",
                    "heavyrain": "Zware regen",
                    "hail": "Hagel",
                    "snow": "Sneeuw"
                },
                "noReportFound": "Geen weer rapport gevonden.",
                "table": {
                    "conditions": "Omstandigheden",
                    "start": "Start",
                    "end": "Eind"
                },
                "metrics": {
                    "temperature": "Temperatuur",
                    "wind": "Wind",
                    "windForce": "Windkracht",
                    "windDirection": "Windrichting",
                    "precipitation": "Neerslag",
                    "cloudiness": "Bewolking"
                }
            },
            "finalReportRoute": {
                "finalReportVisitCard": {
                    "visitNumber": "Bezoeknummer"
                },
                "finalReportSummaryCard": {
                    "title": "Samenvatting",
                    "notAvailable": "Nog geen samenvatting. Deze wordt gegenereerd zodra het bezoek is goedgekeurd.",
                    "beingGenerated": "De samenvatting wordt gegenereerd...",
                    "regenerate": "Samenvatting opnieuw genereren",
                    "notUpdated": "De samenvatting is niet bijgewerkt. Een samenvatting wordt alleen gemaakt voor een goedgekeurd bezoek met een samenvattingssjabloon."
                },
                "finalReportFunctionsCard": {
                    "title": "Functies",
                    "noFunctions": "Er zijn geen functies om te tonen."
                },
                "finalReportWeatherCard": {
                    "weatherCardTitle": "Weerrapport"
                },
                "finalReportWeatherCardTableHeader": {
                    "conditions": "Omstandigheden",
                    "startForm": "Startformulier",
                    "endForm": "Eindformulier"
                },
                "finalReportWeatherCardTableRow": {
                    "metrics": {
                        "temperature": "Temperatuur (°C)",
                        "wind": "Wind",
                        "windForce": "Windkracht (Bft)",
                        "windDirection": "Windrichting",
                        "precipitation": "Neerslag",
                        "cloudiness": "Bewolking %"
                    }
                },
                "finalReportObservationsCard": {
                    "title": "Observaties",
                    "noObservations": "Er zijn geen Observaties om te tonen"
                },
                "finalReportObservationTable": {
                    "labelType": "Soort",
                    "labelWhere": "Waar",
                    "labelAddress": "Adres"
                }
            },
            "rejectButton": {
                "rejectAndReplan": "Bezoek afwijzen en opnieuw inplannen",
                "rejectedOn": "Afgewezen op: {{date}}",
                "dialog": {
                    "title": "Bezoek afwijzen?",
                    "warningMessage": "Weet je zeker dat je dit bezoek wilt afwijzen? Alle rapporten worden afgewezen, de diensten worden geannuleerd en het bezoek zal weer inplanbaar zijn.",
                    "reasonLabel": "Reden voor afwijzing",
                    "reasonRequired": "Reden voor afwijzing is verplicht",
                    "cancel": "Annuleren",
                    "confirm": "Afwijzing bevestigen"
                }
            },
            "errors": {
                "validationCheckFailed": "Kon validatiestatus niet controleren. Probeer het opnieuw."
            },
            "overrideAutoValidation": {
                "reasonForApproval": "Reden voor goedkeuring",
                "revertApprovalBtn": "Goedkeuring intrekken",
                "approveBtn": "Goedkeuren"
            }
        }
    },
    "projectExport": {
        "ProjectExportListScreen": {
            "title": "Exporteren",
            "createdBy": "Gemaakt door",
            "createdAt": "Gemaakt op",
            "researchTypes": "Onderzoekstypen",
            "projectIds": "Projecten",
            "template": "Geëxporteerde bestanden",
            "status": "Status",
            "createButton": "Nieuwe export",
            "deleteDialog": {
                "title": "Export verwijderen",
                "description": "Deze actie kan niet ongedaan worden gemaakt. Doorgaan?"
            }
        },
        "ProjectExportCreateForm": {
            "researchTypes": "Onderzoekstypen",
            "projectIds": "Projecten",
            "selectAll": "Alles selecteren",
            "template": "Geëxporteerde bestanden",
            "mediaIncluded": "Inclusief mediabestanden",
            "createButton": "Aanmaken",
            "disabledResearchTypeSelectionHelper": "Selecteer één of meer projecten"
        },
        "ProjectExportCreateScreen": {
            "title": "Nieuwe export"
        },
        "ProjectExportTable": {
            "delete": "Verwijderen"
        },
        "ExportStatus": {
            "dataFiles": "Gegevensbestanden",
            "mediaFiles": "Mediabestanden"
        }
    },
    "planner": {
        "plannerMenu": {
            "header": "Veldwerkplanning",
            "itemPlanner": "Planner",
            "itemPlanned": "Geplande bezoeken",
            "itemDevTools": "Ontwikkelaarstools"
        },
        "plannerAreaForm": {
            "title": "Gebied",
            "titleProtocolArea": "Protocol",
            "labelName": "Naam",
            "labelProtocols": "Protocolen",
            "labelDescriptionClient": "Beschrijving voor Opdrachtgever",
            "labelDescriptionFieldworker": "Beschrijving voor Veldwerker",
            "labelDescriptionInternal": "Interne Notities",
            "btnSave": "Opslaan"
        },
        "plannerAreaProtocolForm": {
            "title": "Protocol toevoegen",
            "btnAddProtocol": "Protocol toevoegen",
            "btnSubmit": "Protocol opslaan"
        },
        "plannerAreaMedias": {
            "title": "Media",
            "btnAddMedia": "Media toevoegen"
        },
        "plannerMediaDisplay": {
            "labelUnknownFile": "Onbekend bestand"
        },
        "plannerMediaPreviewDialog": {
            "labelMediaPreview": "Media voorbeeld",
            "btnDownload": "Downloaden",
            "btnDelete": "Verwijderen",
            "btnClose": "Sluiten",
            "notUploaded": "Dit bestand is nog niet beschikbaar"
        },
        "plannerAreaEditor": {
            "tabAreas": "Info",
            "tabVisitList": "Bezoeken",
            "tabSettings": "Instellingen"
        },
        "areaVisitList": {
            "plannable": "Planbaar op {{date}}",
            "outOfProtocol": "Plan buiten protocol",
            "overdue": "Te laat",
            "planned": "Geplanned"
        },
        "visitInfo": {
            "workerInfo": "Werkers: {{plannedWorkers}}/{{requiredWorkers}}",
            "visitNumber": "Bezoek {{visitNumber}}",
            "labelTimeslot": "Tijddslot",
            "infoTimeslotNotAllowed": "Cancel all shifts to edit date or timeslot.",
            "timeInfo": "Bezoek begint om {{start}} tot {{end}} (excl reistijd)",
            "visitCombinationPossible": "Shift kan gecombineerd worden met:",
            "visitStartsEarlier": "begint {{minutes}} minuten eerder",
            "visitStartsLater": "begint {{minutes}} minuten later",
            "buttonCombine": "Combineren"
        },
        "visitListScreen": {
            "title": "Geplande bezoeken",
            "areaName": "Gebiedsnaam",
            "visitName": "Bezoek",
            "protocol": "Protocol",
            "startTime": "Starttijd",
            "status": "Status",
            "requiredWorkers": "Benodigde werkers",
            "filterAreaName": "Gebiedsnaam",
            "filterFieldworker": "Veldwerker",
            "filterPossibleFunctions": "Mogelijke functies gevonden",
            "filterSpecies": "Soorten",
            "filterIsPossibleBatRoost": "Vleermuis kraamverblijf?",
            "filterWithoutPossibleEcologicalFunctions": "Geen mogelijke ecologische functies?"
        },
        "plannerVisitList": {
            "noPossibleVisitsOnThisDay": "Geen bezoeken beschikbaar op deze dag",
            "planVisits": "Plan alle bezoeken",
            "planVisit": "Plan bezoek",
            "availableDaysLeft": "{{count}} dagen over",
            "noAvailableDaysLeft": "{{count}} dagen te laat",
            "notYetPlanable": "Nog niet planbaar",
            "checkVisitManually": "Geen dagen over",
            "between": "Tussen"
        },
        "PlannerVisitStatusSelect": {
            "labelStatus": "Bezoekstatus",
            "visitStatusValue": {
                "planned": "Gepland",
                "unplanned": "Niet gepland",
                "awaitingReport": "Wachtend op rapportages",
                "awaitingApproval": "Wachtend op goedkeuring",
                "awaitingConfirm": "Wachtend op bevestiging",
                "awaitingObservationApproval": "Wachtend op goedkeuring van observaties",
                "approved": "Goedgekeurd"
            }
        },
        "PlannerVisitSimplifiedStatusSelect": {
            "labelStatus": "Bezoekstatus",
            "visitStatusValue": {
                "approved": "Goedgekeurd",
                "ecoTeamReview": "Eco Team Review",
                "planned": "Gepland",
                "unplanned": "Niet gepland"
            }
        }
    },
    "plannerV2": {
        "fieldworkerAssignments": {
            "labelNeedsFieldworkers_one": "Dit bezoek heeft {{count}} veldwerker nodig.",
            "labelNeedsFieldworkers_other": "Dit bezoek heeft {{count}} veldwerkers nodig.",
            "labelNeedsMoreFieldworkers_one": "Dit bezoek heeft nog {{count}} veldwerker nodig.",
            "labelNeedsMoreFieldworkers_other": "Dit bezoek heeft nog {{count}} veldwerkers nodig.",
            "labelHasEnoughFieldworkers": "Dit bezoek heeft genoeg veldwerkers.",
            "labelHasMoreThanRequired_one": "Dit bezoek heeft {{count}} veldwerker meer dan vereist.",
            "labelHasMoreThanRequired_other": "Dit bezoek heeft {{count}} veldwerkers meer dan vereist."
        },
        "areaListMapPanel": {
            "areas_one": "{{count}} gebied",
            "areas_other": "{{count}} gebieden",
            "noAreasFound": "Geen gebieden gevonden.",
            "areasNotShown": "{{count}} gebieden niet getoond. Zoom in op de kaart of gebruik de filters om de lijst te verkleinen."
        },
        "areaLists": {
            "atRisk": "Risico",
            "plannable": "Inplanbaar",
            "planned": "Gepland",
            "plannableSoon": "Binnenkort"
        },
        "mapDatepicker": {
            "previousDay": "Vorige dag",
            "nextDay": "Volgende dag",
            "openCalendar": "Kalender openen"
        },
        "plannerStatus": {
            "impossible": "Onmogelijk",
            "notYetPlannable": "Nog niet Inplanbaar",
            "planned": "Gepland",
            "plannableOk": "Inplanbaar",
            "plannableSoon": "Binnenkort planbaar",
            "warning": "Waarschuwing",
            "plannableAtRisk": "Inplanbaar met Risico",
            "outOfProtocol": "Buiten Protocol"
        },
        "visitStatusTimeline": {
            "impossible": "Dit bezoek is onmogelijk in te plannen. Het protocol is niet correct geconfigureerd.",
            "notYetPlannable": "Dit bezoek is nog niet inplanbaar. Het zal beschikbaar zijn om in te plannen op <bold>{{formattedFirstStartDate}}</bold>.",
            "outOfProtocol": "Dit bezoek valt buiten het protocol. De laatst beschikbare datum was <bold>{{formattedLatestEndDate}}</bold>.",
            "plannableAtRisk": "Dit bezoek loopt risico. Plan voor <bold>{{formattedLatestEndDate}}</bold> om binnen het protocol te blijven.",
            "plannableOk": "Dit bezoek is inplanbaar. Plan voor <bold>{{formattedLatestEndDate}}</bold> om binnen het protocol te blijven.",
            "plannableSoon": "Dit bezoek is binnenkort te plannen. Plan voor <bold>{{formattedLatestEndDate}}</bold> om binnen het protocol te blijven.",
            "planned": "Dit bezoek is gepland."
        },
        "addToVisitButton": {
            "addToVisit": "Toevoegen aan bezoek",
            "addToCarpool": "Toevoegen aan carpool",
            "withPerson": "Met {{personName}}",
            "asBiker": "Als fietser ({{distanceInKm}} km,{{durationInMinutes}})"
        },
        "visitDetail": {
            "timeslot": "Tijdslot",
            "addFieldworkerInstruction": "Voeg een veldwerker toe vanaf de kaart om ze in te plannen voor dit bezoek.",
            "visitNumber": "Bezoek {{visitNumber}}",
            "carpool": "Carpool",
            "driver": "Bestuurder",
            "removeFieldworker": "Verwijder {{name}}",
            "longBikeRideWarning": "Deze fietsrit duurt langer dan {{minutes}} minuten.",
            "distanceExplanation": "Afstand {{travelMethod}}",
            "travelMethod": {
                "bike": "met de fiets",
                "privateCar": "met de auto",
                "myWheels": "met een MyWheels-auto",
                "pickup": "met de auto (meerijder)"
            },
            "openInReviewTool": "Openen in Review Tool"
        },
        "visitPlannedOnDates": {
            "plannedOn": "Gepland op {{date}} ({{carpools}} carpool(s))",
            "cancelledOn": "Geannuleerd op {{date}} ({{carpools}} carpool(s))",
            "replanOn": "Opnieuw plannen op {{date}}"
        },
        "cancelCarpool": {
            "title": "Carpool annuleren?",
            "description": "Het annuleren van deze carpool zal ook de diensten voor de passagiers annuleren."
        },
        "reviewPlanPanel": {
            "visitsDrafted_one": "{{count}} concept bezoek",
            "visitsDrafted_other": "{{count}} concept bezoeken",
            "reviewAndPlanButton": "Planning Bevestigen",
            "reviewAndPlan": "Planning Bevestigen",
            "toBeCancelled": "Bezoeken die geannuleerd worden",
            "toBePlanned": "Bezoeken die ingepland worden",
            "successTitle": "Gefeliciteerd! 🥳",
            "successMessage": "Je hebt de planning bevestigd en de relevante veldwerkers op de hoogte gesteld.",
            "keepPlanning": "Doorgaan met plannen",
            "noVisitsDrafted": "Geen concept bezoeken",
            "selectAll": "Selecteer alles",
            "confirmSelected": "Bevestig ({{selectedCount}})",
            "cancelSelected": "Wis ({{selectedCount}})",
            "notificationHint": "Bij bevestigen worden klanten en veldwerkers geïnformeerd.",
            "confirmDialogTitle": "Planning Bevestigen",
            "confirmDialogDescription_one": "Weet je zeker dat je {{count}} geselecteerde aanpassing wilt bevestigen? Alle relevante veldwerkers worden op de hoogte gesteld.",
            "confirmDialogDescription_other": "Weet je zeker dat je {{count}} geselecteerde aanpassingen wilt bevestigen? Alle relevante veldwerkers worden op de hoogte gesteld.",
            "cancelDialogTitle": "Aanpassingen Wissen",
            "cancelDialogDescription_one": "Weet je zeker dat je {{count}} geselecteerde aanpassing wilt wissen? Dit zet het bezoek terug naar de eerder gepubliceerde planning.",
            "cancelDialogDescription_other": "Weet je zeker dat je {{count}} geselecteerde aanpassingen wilt wissen? Dit zet de bezoeken terug naar de eerder gepubliceerde planning.",
            "reviewMoreVisits_one": "Bekijk {{count}} extra concept bezoek",
            "reviewMoreVisits_other": "Bekijk {{count}} extra concept bezoeken",
            "unknownUser": "Onbekend",
            "userCount": "{{selected}}/{{total}}",
            "currentUserSuffix": "ik",
            "searchPlaceholder": "Zoek klant, project, gebied of veldwerker",
            "noSearchResults": "Geen resultaten gevonden"
        },
        "routeDetail": {
            "route": "Route",
            "distance": "afstand",
            "duration": "reisduur",
            "time": "tijd",
            "driver": "Bestuurder"
        },
        "routeActivity": {
            "departs": "{{name}} vertrekt",
            "isPickedUp": "{{name}} wordt opgehaald",
            "isDroppedOff": "{{name}} wordt afgezet",
            "arrives": "{{name}} arriveert"
        },
        "travelMethod": {
            "privateCar": "Privé Auto",
            "myWheels": "MyWheels",
            "bike": "Fiets"
        },
        "passengerHomeAddressMarkers": {
            "home": "{{names}}'s Thuis"
        },
        "gaiaExpandableMapMarkerArea": {
            "addVisitForCarpool": "Voeg bezoek toe aan carpool",
            "splittingCarpoolInto": "Carpool splitsen in bezoek:",
            "back": "Terug"
        },
        "gaiaExpandableMapMarkerFieldworker": {
            "maxShiftsPerWeek": "Max. diensten per week"
        },
        "areaFilters": {
            "title": "Gebieden filteren",
            "clientFilter": "Klant",
            "projectFilter": "Project",
            "plannerAreaFilter": "Gebied",
            "fieldworkerFilter": "Gepland Veldwerker",
            "researchTypeFilter": "Onderzoekstype"
        },
        "visitFilters": {
            "title": "Veldwerkers filteren",
            "fieldworkerFilter": "Naam",
            "includeUnavailableFilter": "Niet-beschikbare veldwerkers meenemen"
        },
        "maxRequiredFieldworkersFilter": {
            "label": "Maximaal benodigd aantal veldwerkers",
            "sliderAriaLabel": "Maximaal benodigd aantal veldwerkers"
        }
    },
    "observation": {
        "observationStatus": {
            "approved": "Approved",
            "rejected": "Rejected",
            "awaitingApproval": "Awaiting approval",
            "deleted": "Deleted",
            "incomplete": "Incomplete"
        },
        "observationForm": {
            "labelType": "Type",
            "labelSpecies": "Diersoort",
            "selectItem": "-- Selecteer --",
            "labelCreatedAt": "Aangemaakt op {{createdAt}}",
            "btnSave": "Opslaan",
            "rateObservation": "Beoordeel de observatie",
            "labelDetails": "Details"
        },
        "observationMedias": {
            "title": "Observatiemedia"
        },
        "observationLink": {
            "link": "Verbinding"
        },
        "observationSubmitButton": {
            "reject": "Afwijzen",
            "approve": "Goedkeuren",
            "save": "Opslaan"
        },
        "observationPreciseLocationForm": {
            "title": "Precieze Locatie",
            "labelNotSpecified": "Niet gespecificeerd",
            "btnAddPreciseLocation": "Precieze Locatie Toevoegen",
            "btnClose": "Sluiten",
            "address": "Adres: ",
            "where": "Waar: ",
            "component_roof": "Dak: ",
            "component_wall": "Muur: ",
            "component_terrain": "Terrein: ",
            "other": "Overig: ",
            "side": "Zijde: ",
            "btnSave": "Opslaan"
        },
        "observationApprovalDialog": {
            "title": "Link conclusie",
            "cancel": "Annuleren",
            "createConclusion": "Maak nieuwe conclusie",
            "existingConclusion": "Selecteer conclusie van kaart",
            "createConclusionManually": "(Conclusiefunctie handmatig aanmaken en opnieuw koppelen)"
        },
        "linkedObservations": {
            "conclusion": "Conclusie observatie",
            "observations": "Gekoppelde observaties"
        }
    },
    "payments": {
        "paymentListScreen": {
            "title": "Betalingen"
        },
        "paymentRecordAllUser": {
            "title": "Onbetaalde betalingen",
            "colName": "Naam",
            "colAmount": "Bedrag",
            "colTotal": "Totaal",
            "totalUnpaid": "Totaal onbetaald",
            "btnMakeTentooPayment": "Tentoo betaling uitvoeren",
            "btnMakeOtherPayment": "Non-Tentoo betaling uitvoeren"
        },
        "paidPayments": {
            "title": "Betalingen",
            "colName": "Naam",
            "colCreatedAt": "Aangemaakt op",
            "colPeriod": "Periode",
            "colScope": "Scope",
            "colDay": "Dag",
            "colNight": "Nacht",
            "colDistance": "Afstand",
            "totalPaid": "Totaal betaald",
            "btnDownload": "Downloaden"
        },
        "paymentRecordTable": {
            "colAmount": "Bedrag",
            "colDescription": "Beschrijving",
            "colPrice": "Prijs",
            "colTotal": "Totaal",
            "colDelete": "Verwijderen",
            "totalAmount": "Totaal bedrag"
        }
    },
    "media": {
        "fileDropZone": {
            "text": "Sleep & plaats of <1>Bladeren</1>"
        },
        "photoUploadDialog": {
            "btnCancel": "Annuleren",
            "btnSave": "Opslaan"
        },
        "fileUploadDialog": {
            "btnCancel": "Annuleren",
            "btnSave": "Opslaan"
        }
    },
    "map": {
        "toggleBaseMap": "Basismap veranderen",
        "mapButtonFitBounds": {
            "centerOn": {
                "features": "Centreren op objecten",
                "feature": "Centreren op object",
                "layer": "Centreren op laag",
                "area": "Centreren op gebied",
                "areas": "Centreren op gebieden",
                "route": "Centreren op route",
                "visit": "Centreren op bezoek",
                "netherlands": "Centreren op Nederland",
                "address": "Centreren op adres"
            },
            "option": {
                "features": "Objecten",
                "feature": "Object",
                "layer": "Laag",
                "area": "Gebied",
                "areas": "Gebieden",
                "route": "Route",
                "visit": "Bezoek",
                "netherlands": "Nederland",
                "address": "Adres"
            },
            "openOptions": "Centreeropties",
            "editAddress": "Adres wijzigen",
            "back": "Terug",
            "labelAddress": "Adres",
            "labelAddressNoOptions": "Vul een straat en huisnummer in",
            "addressLookupFailed": "De locatie van dit adres kon niet worden gevonden",
            "btnCenter": "Centreren"
        },
        "mapShapeIcon": {
            "Square": "Vierkant",
            "TriangleUp": "Driehoek omhoog",
            "TriangleDown": "Driehoek omlaag",
            "Circle": "Cirkel",
            "Pentagon": "Vijfhoek",
            "Diamond": "Ruit",
            "Hexagon": "Zeshoek",
            "Plus": "Plus",
            "StarThree": "Ster met 3 punten",
            "StarFour": "Ster met 4 punten",
            "StarFive": "Ster met 5 punten",
            "StarSix": "Ster met 6 punten"
        }
    },
    "mapEditor": {
        "layerType": {
            "Other": "Overig",
            "Areas": "Gebieden",
            "MediaPoints": "Media punten",
            "Observations": "Observaties",
            "EcologicalFunctions": "Functies"
        },
        "drawing": {
            "draw": "Teken",
            "drawing": "Tekenen..."
        },
        "featureType": {
            "LineString": "Lijn",
            "Point": "Punt",
            "Polygon": "Gebied"
        },
        "MapEditorFeatureDetails": {
            "noTitle": "Kenmerk",
            "featureDelete": {
                "btnDelete": "Kenmerk verwijderen"
            }
        },
        "mapEditorFilters": {
            "observationType": "Observatietype"
        },
        "mapEditorLayersTree": {
            "title": "Lagen",
            "showAll": "Toon alles",
            "hideAll": "Verberg alles",
            "btnNewLayer": "Nieuwe laag"
        },
        "mapEditorLayerCreateDialog": {
            "title": "Nieuwe datalaag",
            "create": "Aanmaken",
            "import": "Importeren"
        },
        "mapEditorLayerImport": {
            "couldNotImport": "Bestand kon niet worden geïmporteerd. Is het formaat juist?"
        },
        "mapEditorLayerForm": {
            "title": "Datalag toevoegen",
            "labelName": "Naam",
            "labelProtocol": "Selecteer protocollen",
            "btnSave": "Opslaan",
            "btnCancel": "Annuleren",
            "labelShowDuringFieldwork": "Weergeven tijdens veldwerk"
        },
        "mapEditorLayerDetails": {
            "btnDelete": "Laag verwijderen",
            "labelName": "Naam",
            "labelStyle": "Stijl",
            "labelProtocols": "Protocollen",
            "labelShowDuringFieldwork": "Weergeven tijdens veldwerk",
            "btnSave": "Opslaan",
            "showToClientUser": "Toon aan klantgebruikers"
        },
        "mapEditorFeatureCollectionsPane": {
            "importFeatureCollectionFiles": "Bestanden importeren",
            "plannerAreaFeatureCollection": "Planningsgebieden",
            "walkingRouteFeatureCollection": "Wandelroutes",
            "pointsOfInterestFeatureCollection": "Interessante punten",
            "layerName": "Laagnaam",
            "addLayer": "Laag toevoegen",
            "noPlannerAreas": "Planningsgebieden nog niet geconfigureerd"
        },
        "mapEditorFeatureCollectionsDetail": {
            "editFeatureCollectionTitle": "Laag bewerken",
            "saveButton": "Opslaan",
            "updateButton": "Bijwerken",
            "deleteButton": "Verwijderen"
        },
        "mapEditorFeatureDetail": {
            "editFeatureTitle": "Kenmerk bewerken van",
            "updateButton": "Bijwerken",
            "deleteButton": "Verwijderen"
        },
        "featureDetailObservation": {
            "title": "Observatie",
            "validationStatusAlert": {
                "title": "Niet alle velden zijn voltooid"
            },
            "observationType": "Soort observatie",
            "observationTypeRequired": "Observatietype is verplicht",
            "species": "Diersoort",
            "createdAt": "Gemaakt op",
            "media": "Media",
            "preciseLocation": "Precieze Locatie",
            "observationDetails": "Observatiedetails",
            "btnCancel": "Annuleren",
            "btnSave": "Opslaan",
            "btnReject": "Afwijzen",
            "btnRejectSmall": "Observatie Afwijzen",
            "btnApprove": "Goedkeuren",
            "btnDisabledIncomplete": "Voltooi deze observatie om de status aan te passen",
            "cloneDialogTitle": "Observatie klonen",
            "cloneDialogDescription": "Dit maakt een kopie van de observatie met bijbehorende eigenschappen en media. Koppelingen naar ecologische functies worden niet overgenomen.",
            "labelFeedback": "Feedback",
            "labelFeedbackRating": "Feedback",
            "labelFeedbackComment": "Opmerking"
        },
        "featureDetailEcologicalFunction": {
            "title": "Ecologische functie",
            "ecologicalFunctionType": "Functie type",
            "species": "Diersoort",
            "createdAt": "Gemaakt op",
            "media": "Media",
            "preciseLocation": "Precieze Location",
            "ecologicalFunctionDetails": "Functie details"
        },
        "featureDetailArea": {
            "title": "Planningsgebied",
            "tabVisitList": "Bezoeken",
            "tabSettings": "Instellingen"
        },
        "featureDetailAreaSettings": {
            "labelName": "Naam",
            "labelStatus": "Status",
            "confirmedStatusLabel": "Bevestigd",
            "onHoldStatusLabel": "Gepauzeerd",
            "cancelledStatusLabel": "Geannuleerd",
            "labelDescription": "Beschrijving",
            "labelDescriptionClient": "Beschrijving (Klant)",
            "labelDescriptionFieldworker": "Beschrijving (Veldwerker)",
            "labelDescriptionInternal": "Beschrijving (Intern)",
            "clientSectionTitle": "Klant",
            "clientSectionCaption": "Deze sectie is alleen zichtbaar voor klanten",
            "fieldworkerSectionTitle": "Veldwerker",
            "fieldworkerSectionCaption": "Deze sectie is alleen zichtbaar voor veldwerkers",
            "internalSectionTitle": "Intern",
            "internalSectionCaption": "Deze sectie is alleen zichtbaar voor admins",
            "btnSave": "Opslaan",
            "media": "Media",
            "protocols": "Protocollen",
            "btnAddProtocol": "Protocol toevoegen",
            "modal": {
                "title": "Protocol toevoegen",
                "labelTitle": "Kies een protocol",
                "btnSubmit": "Toevoegen"
            },
            "statusChangeNotAllowed": "Naar deze status wijzigen is op dit moment niet mogelijk"
        },
        "featureDetailMediaPoint": {
            "title": "Mediapunt",
            "createdAt": "Gemaakt op",
            "detections": "Detecties",
            "btnSave": "Opslaan"
        },
        "featureDetailOther": {
            "title": "Overig kenmerk"
        },
        "mapEditorAddressImport": {
            "title": "Adres importeren",
            "imported": "Geïmporteerd",
            "addresses": "adressen.",
            "errorMessage": "{{numberOfErrors}} adressen konden niet worden geïmporteerd. Je ontvangt een e-mail met de missende adressen.",
            "outOf": "van de",
            "closestMatch": "Dichtstbijzijnde overeenkomst"
        },
        "layerConfigDetails": {
            "labelType": "Type",
            "labelSpecies": "Soorten"
        },
        "ecologicalFunctionCard": {
            "btnLink": "Koppelen",
            "btnUnlink": "Ontkoppelen",
            "labelMedia": "Media"
        },
        "ecologicalFunctionLinking": {
            "dividerTitle": "Functies toevoegen",
            "dividerLinkedFunctions": "Gekoppelde functies",
            "tabCreateNew": "Nieuwe aanmaken",
            "tabLinkToExisting": "Koppelen aan bestaande",
            "labelFunctionType": "Functietype",
            "btnCreate": "Aanmaken",
            "noLinkableFunctions": "Geen Functies beschikbaar om te koppelen",
            "noLinkableFunctionTypes": "Geen koppelbare Functietypes geconfigureerd"
        },
        "observationCard": {
            "labelSpecies": "Diersoort",
            "labelObservationType": "Soort observatie",
            "btnLink": "Koppelen",
            "btnUnlink": "Ontkoppelen",
            "labelMedia": "Media",
            "btnShowDetails": "Details tonen ({{count}})",
            "btnHideDetails": "Details verbergen ({{count}})"
        },
        "observationLinking": {
            "dividerTitle": "Observaties toevoegen",
            "dividerLinkedObservations": "Gekoppelde observaties",
            "noLinkableObservations": "Geen Observaties beschikbaar om te koppelen."
        },
        "mapEditorVisitLists": {
            "startTimeText": "Start tijd: <strong>{{datetime}}</strong>",
            "visitStatus": {
                "planned": "Gepland",
                "unplanned": "Niet gepland",
                "draft": "Concept",
                "awaitingReport": "Wachtend op rapportages",
                "awaitingApproval": "Wachtend op goedkeuring",
                "awaitingConfirm": "Wachtend op bevestiging",
                "awaitingObservationApproval": "Wachtend op goedkeuring van observaties",
                "approved": "Goedgekeurd",
                "rejected": "Afgekeurd"
            },
            "workers": "Aantal werknemers",
            "routeStartDirection": "Route richting",
            "routeStartOffset": "Route start"
        },
        "mapEditorFeatureList": {
            "labelNoFeatures": "Geen objecten beschikbaar.",
            "labelNoTitle": "Geen titel beschikbaar",
            "labelFeatureList": "Objectenlijst",
            "labelSettings": "Instellingen"
        },
        "mapEditorFeatureDetails": {
            "labelProperties": "Eigenschappen",
            "labelKey": "Sleutel",
            "labelValue": "Waarde",
            "labelObservations": "Observaties"
        },
        "mapEditorPropertiesGrid": {
            "colKey": "Sleutel",
            "colValue": "Waarde",
            "addRow": "Eigenschap toevoegen"
        },
        "mapEditorFeatureCreateDialog": {
            "title": "Nieuw item aanmaken",
            "subtitle": "Selecteer een actie",
            "btnCancel": "Annuleren",
            "btnStartDrawing": "Begin met tekenen",
            "drawTypeSection": {
                "title": "Wat wil je tekenen?",
                "labelDrawArea": "Teken Gebied / Route",
                "labelAddObservation": "Voeg waarneming toe",
                "labelAddFunction": "Voeg functie toe",
                "labelDrawOther": "Teken anders"
            },
            "plannerAreaSection": {
                "title": "Teken type",
                "labelProtocol": "Protocol"
            },
            "observationSection": {
                "labelSpecies": "Diersoort",
                "labelNoSpecies": "Geen soorten beschikbaar",
                "labelSelectObservationType": "Selecteer waarnemingstype"
            },
            "ecologicalFunctionSection": {
                "labelSelectEcologicalFunctionType": "Selecteer ecologische functietype"
            }
        },
        "mapEditorFeatureCreateOptions": {
            "sectionPlannerArea": "Planningsgebied",
            "labelArea": "Gebied",
            "labelRoute": "Route",
            "labelPolygon": "Polygon",
            "labelLine": "Lijn",
            "labelPoint": "Punt",
            "labelSelectProtocols": "Selecteer protocollen",
            "sectionObservation": "Waarneming"
        },
        "mapEditorFeatureCreateButton": {
            "labelDrawSomething": "Teken iets",
            "labelDrawObservation": "Teken {{observationType}}",
            "labelDrawPlannerArea": "Teken planningsgebied",
            "labelDrawEcologicalFunction": "Teken {{ecologicalFunctionType}}",
            "labelDrawOtherObject": "Teken ander object",
            "btnChange": "Wijzigen",
            "ariaLabelChangeDrawOption": "Wijzig tekenoptie"
        },
        "mapEditorFeatureDetailMediaPoint": {
            "labelMediaPoint": "Mediapunt:"
        },
        "speciesGroupTree": {
            "label": "Diersoorten"
        },
        "ecologicalFunctionTypeTree": {
            "label": "Functies"
        },
        "observationTypeTree": {
            "label": "Observatietypen"
        },
        "protocolTree": {
            "label": "Bezoeken",
            "visit": "Bezoek"
        },
        "featureDetailPlannerAreaVisitList": {
            "confirmDeleteModal": {
                "title": "Bezoek verwijderen?",
                "alertMessage": "Dit bezoek wordt zacht verwijderd. De verwijdering wordt vastgelegd met je naam en reden.",
                "reason": "Reden voor verwijdering",
                "btnCancel": "Annuleren",
                "btnSubmit": "Verwijderen"
            }
        }
    },
    "fieldworker": {
        "fieldworkerMenu": {
            "header": "Veldwerker",
            "availability": "Beschikbaarheid",
            "planning": "Kalender",
            "shifts": "Dienstroosters",
            "feedback": "Feedback"
        },
        "fieldworkerAvailabilityForm": {
            "labelMaxShiftsPerWeek": "Maximale diensten per week",
            "noCoolOffBetweenShifts": "Ochtenddienst na avonddienst toestaan",
            "btnSave": "Opslaan",
            "notes": "Note: in uitzonderlijke gevallen kunnen de tijden verschillen van bovenstaande tijden. In dat geval zal er op voorhand contact met je opgenomen worden."
        },
        "fieldworkerAvailabilityScreen": {
            "availabilityTitle": "Beschikbaarheid",
            "availabilityContent1": "In onderstaand overzicht kan je jouw algemene beschikbaarheid opgeven. Let op: naast je beschikbaarheid kan je opgeven hoeveel shifts per week je maximaal wilt lopen. Twee weken van tevoren gaat jouw beschikbaarheid op slot en kan je deze niet meer aanpassen.",
            "availabilityContent2": "De meeste shifts duren 2 tot 3 uur exclusief de reistijd. We proberen je zo veel mogelijk in te delen in shifts die minder dan een uur rijden zijn.",
            "availabilityContent3": "Aan de hand van jouw opgegeven beschikbaarheid zullen wij een planning maken. De planning wordt wekelijks gemaakt en hangt af van verschillende factoren (o.a. periode en weer). Beschikbaarheid betekent dan ook niet gegarandeerd werk.",
            "availabilityAttention": "Let op: ",
            "availabilityContent4": "Gedurende het seizoen vragen wij een beschikbaarheid van minstens twee diensten per week. Daarbovenop dien je tijdens de voorjaarsrondes naar vleermuizen minstens één ochtenddienst per week beschikbaar te zijn.",
            "addTimeOff": "Voeg verlof toe"
        },
        "calendarDay": {
            "saveChanges": "Wijzigingen opslaan"
        },
        "calendarTimeOffPlanPopup": {
            "title": "Vrije tijd",
            "titleEdit": "Bewerk verlofaanvraag",
            "titleAdd": "Verlofaanvraag toevoegen",
            "labelStartTime": "Starttijd",
            "labelEndTime": "Eindtijd",
            "labelReason": "Reden",
            "labelDelete": "Verwijderen",
            "labelEdit": "Save",
            "labelAdd": "Toevoegen",
            "btnClose": "Sluiten",
            "errorEndBeforeStart": "Eindtijd moet na de starttijd liggen",
            "errorDescriptionIsRequired": "Beschrijving is verplicht"
        },
        "fieldworkerWelcomeMessage": {
            "title": "Welkom {{firstName}}",
            "description": "Je hebt alles ingevuld om aan de slag te gaan als veldwerker. Klik linksboven op het menu om je beschikbaarheid aan te passen of je kalender in te zien. Vrije dagen kan je direct via de kalender aanvragen."
        },
        "shifts": {
            "title": "Dienstenoverzicht",
            "noShifts": "Geen diensten om weer te geven"
        },
        "shiftItem": {
            "labelDate": "Datum",
            "labelType": "Type",
            "labelDistance": "Afstand",
            "labelDuration": "Duur",
            "labelNoPayment": "Er is geen betaling gedaan",
            "labelShiftToBeApproved": "Dienst moet nog worden goedgekeurd voor betaling",
            "labelShiftToBePaid": "Dienst moet nog worden betaald",
            "labelShiftReadyForPayment": "Klaar voor betaling",
            "labelShiftPaid": "Dienst betaald",
            "labelCarpool": "Carpool",
            "labelMyWheels": "MyWheels"
        },
        "shiftVisits": {
            "btnOpenPlanner": "Openen in planner",
            "btnOpenPlannedVisit": "Openen in geplande bezoeken",
            "labelReports": "Verslagen",
            "labelNoNotes": "No notes"
        },
        "FieldworkerFeedbackListScreen": {
            "title": "Feedback",
            "subtitle": "Bekijk hier de feedback op je recente diensten. Als u vragen heeft over uw feedback, neem dan contact op met uw begeleider.",
            "noFeedback": "Je hebt nog geen feedback ontvangen"
        },
        "FieldworkerFeedbackScreen": {
            "feedback": "Feedback",
            "observations": "Observaties met feedback",
            "noObservations": "Geen observaties met feedback",
            "ObservationListItem": {
                "feedback": "Feedback",
                "medias": "Media",
                "echometer": "Echometer"
            },
            "visitConditions": "Weersomstandigheden",
            "titleStartForm": "Startformulier",
            "titleSubmittedForm": "Eindformulier",
            "visitConditionsUnavailable": "Weersomstandigheden niet beschikbaar"
        },
        "fieldworkerFeedbackScreen": {
            "title": "Feedback"
        }
    },
    "settings": {
        "settingsListRoute": {
            "title": "Instellingen"
        },
        "settingsOptionsList": {
            "speciesDatabase": {
                "name": "Soorten­database",
                "description": "Bekijk en bewerk de volledige soorten­database"
            },
            "researchTypes": {
                "name": "Onderzoekstypen",
                "description": "Maak onderzoekstypen aan en wijzig observatievelden"
            },
            "researchRequirements": {
                "name": "Onderzoekseisen",
                "description": "Definieer vereisten (bijv. uitrustingslijsten, trainingscertificaten, enz.)"
            },
            "masterForms": {
                "name": "Standaardformulieren",
                "description": "Wijzig standaardformulier­velden en app-specifieke formulieren"
            },
            "protocolTemplates": {
                "name": "Protocoltemplates",
                "description": "Bekijk, bewerk en maak nieuwe protocoltemplates"
            }
        }
    },
    "species": {
        "settingsSpeciesListRoute": {
            "title": "Soortendatabase",
            "headerName": "Naam",
            "headerScientificName": "Wetenschappelijke naam",
            "headerDescription": "Beschrijving",
            "filterSearch": "Zoeken op naam"
        },
        "settingsSpeciesCreateRoute": {
            "title": "Nieuw Soort"
        },
        "settingsSpeciesEditRoute": {
            "title": "Soort bewerken",
            "dangerZone": "Gevaarzone",
            "speciesDeleteBtn": "Soort verwijderen"
        },
        "speciesForm": {
            "labelName": "Naam",
            "labelDescription": "Beschrijving",
            "labelScientificName": "Wetenschappelijke naam",
            "labelIsRareSpecies": "Zeldzame soort",
            "labelMapColor": "Kaartkleur",
            "btnSubmit": "Opslaan"
        }
    },
    "researchType": {
        "settingsResearchTypeListRoute": {
            "title": "Onderzoekstypen",
            "headerName": "Naam",
            "headerSpecies": "Soorten",
            "headerDescription": "Beschrijving",
            "filterSearch": "Zoeken op naam"
        },
        "settingsResearchTypeCreateRoute": {
            "title": "Nieuw Onderzoekstype"
        },
        "researchTypeCreateForm": {
            "labelName": "Naam",
            "labelDescription": "Beschrijving",
            "labelRequireRecordings": "Opnames verplicht",
            "labelSpecies": "Selecteer één of meer soorten",
            "btnSubmit": "Opslaan"
        },
        "settingsResearchTypeEditRoute": {
            "title": "Onderzoekstype bewerken",
            "visitSummaryTemplateTitle": "Samenvattingssjabloon",
            "dangerZone": "Gevaarzone",
            "researchTypeDeleteBtn": "Onderzoekstype verwijderen",
            "researchTypeSpeciesListTitle": "Soorten",
            "observationTypeListTitle": "Observatietypen",
            "btnCreateObservationType": "Observatietype maaken",
            "formTemplateEditorTitle": "Dagverslagformuliervelden",
            "functionTypeListTitle": "Functietypen",
            "btnCreateFunctionType": "Functietype maaken"
        },
        "visitSummaryTemplateForm": {
            "labelTemplate": "Sjabloon (JSON)",
            "helperText": "Bepaalt welke zinnen de bezoeksamenvatting krijgt. Wordt toegepast op bezoeken die hierna worden goedgekeurd. Laat leeg om het sjabloon te verwijderen.",
            "errorInvalidJson": "Dit is geen geldige JSON.",
            "btnSubmit": "Opslaan"
        },
        "researchTypeUpdateForm": {
            "labelName": "Naam",
            "labelDescription": "Beschrijving",
            "labelRequireRecordings": "Opnames verplicht",
            "btnSubmit": "Opslaan"
        },
        "researchTypeSpeciesListCard": {
            "actionAddSpecies": "Soort toevoegen"
        },
        "researchTypeSpeciesForm": {
            "actionAddSpecies": "Soort toevoegen",
            "labelAddSpecies": "Selecteer soort",
            "labelShowToClientUser": "Altijd aan klant laten zien",
            "btnSubmit": "Opslaan",
            "btnTooltip": "Alle soorten zijn toegevoegd"
        },
        "researchTypeSpeciesDataGrid": {
            "headerName": "Naam",
            "headerScientificName": "Wetenschappelijke naam",
            "headerShowToClientUser": "Toon aan klant",
            "headerDelete": "Verwijderen"
        },
        "observationTypeDataGrid": {
            "headerName": "Naam",
            "headerDescription": "Beschrijving"
        },
        "functionTypeDataGrid": {
            "headerName": "Naam",
            "headerObservationTypes": "Ondersteunende observaties"
        }
    },
    "observationType": {
        "settingsObservationTypeCreateRoute": {
            "title": "Nieuw Observatietype"
        },
        "observationTypeCreateForm": {
            "labelName": "Naam",
            "labelDescription": "Beschrijving",
            "labelFeatureType": "Geometrietype",
            "labelPoint": "Punt",
            "labelLineString": "Lijn",
            "labelPolygon": "Gebied",
            "btnSubmit": "Opslaan"
        },
        "settingsObservationTypeEditRoute": {
            "title": "Observatietype bewerken",
            "formTemplateEditorTitle": "Formuliervelden",
            "dangerZone": "Gevaarzone",
            "observationTypeDeleteBtn": "Observatietype verwijderen",
            "observationTypeFunctionTypeListTitle": "Functietypes"
        },
        "observationTypeUpdateForm": {
            "labelName": "Naam",
            "labelDescription": "Beschrijving",
            "labelFeatureType": "Geometrietype",
            "labelPoint": "Punt",
            "labelLineString": "Lijn",
            "labelPolygon": "Gebied",
            "requiredFieldsDivider": "Verplichte velden",
            "requiredFieldsInfo": "Naast de velden die je hieronder toevoegt, bevat deze flow een set standaardvelden die bij elke observatie worden weergegeven. Deze formulieren velden hieronder getoond en kunnen als verplicht worden ingesteld voor dit specifieke observatietype. Hierdoor kan een observatie niet worden afgerond zonder deze velden in te vullen.",
            "labelRequireMedia": "Media verplicht",
            "labelRequirePreciseLocation": "Nauwkeurige locatie verplicht",
            "labelShowToClientUser": "Altijd aan klant laten zien",
            "btnSubmit": "Opslaan"
        },
        "observationTypeFunctionTypeListCard": {
            "actionAddFunctionType": "Functietype toevoegen"
        },
        "observationTypeFunctionTypeForm": {
            "btnSubmit": "Opslaan"
        },
        "observationTypeFunctionTypeDataGrid": {
            "headerName": "Naam",
            "headerDelete": "Verwijderen"
        },
        "observationTypeFunctionTypeSelectElement": {
            "labelAddFunctionType": "Functietype toevoegen"
        }
    },
    "functionType": {
        "settingsFunctionTypeCreateRoute": {
            "title": "Nieuw Functietype"
        },
        "functionTypeForm": {
            "labelName": "Naam",
            "labelDescription": "Beschrijving",
            "labelFeatureType": "Feature type",
            "labelPoint": "Point",
            "labelLineString": "LineString",
            "labelPolygon": "Polygon",
            "labelIsEssential": "Is essentieel",
            "labelMapIcon": "Kaarticoon",
            "btnSubmit": "Save"
        },
        "settingsFunctionTypeEditRoute": {
            "title": "FunctieType bewerken",
            "formTemplateEditorTitle": "Formuliervelden",
            "dangerZone": "Danger Zone",
            "functionTypeDeleteBtn": "Functietype verwijderen",
            "functionTypeObservationTypeListTitle": "Observatietypes"
        },
        "functionTypeObservationTypeListCard": {
            "actionAddObservationType": "Observatietype toevoegen"
        },
        "functionTypeObservationTypeDataGrid": {
            "headerName": "Naam",
            "headerDelete": "Verwijderen"
        },
        "functionTypeObservationTypeForm": {
            "btnSubmit": "Opslaan"
        },
        "functionTypeObservationTypeSelectElement": {
            "labelAddObservationType": "Observatietype toevoegen"
        }
    },
    "course": {
        "courseListScreen": {
            "title": "Onderzoekseisen"
        },
        "courseCreateScreen": {
            "title": "Nieuwe Onderzoekseis"
        },
        "courseEditScreen": {
            "title": "Onderzoekseis bewerken",
            "dangertitle": "Gevaarlijke zone"
        },
        "courseDataGrid": {
            "headerName": "Naam",
            "headerDescription": "Beschrijving",
            "externalReference": "Externe referentie",
            "filterSearch": "Zoeken op naam"
        },
        "courseForm": {
            "labelName": "Naam",
            "labelDescription": "Beschrijving",
            "labelexternalReference": "Externe referentie",
            "btnSubmit": "Opslaan"
        },
        "courseDeleteButton": {
            "btnDelete": "Onderzoekseis verwijderen"
        },
        "courseUserProtocol": {
            "type": "Onderzoekseis toevoegen",
            "btnSubmit": "Onderzoekseis opslaan",
            "btnTooltip": "Alle onderzoekseisen zijn toegevoegd"
        }
    },
    "formTemplateEditor": {
        "formTemplateEditor": {
            "btnAddField": "Veld toevoegen"
        },
        "formTemplateQuestionForm": {
            "btnDelete": "Veld verwijderen",
            "btnCancel": "Annuleren",
            "btnSave": "Opslaan",
            "labelType": "Type",
            "labelName": "Naam",
            "labelRequired": "Verplicht",
            "labelShowToClientUser": "Altijd aan klant laten zien",
            "labelDescription": "Beschrijving",
            "labelPlaceholder": "Placeholder",
            "labelDefaultValue": "Standaardwaarde",
            "labelTags": "Tags",
            "typeText": "Tekst",
            "typeAmount": "Aantal",
            "typeRecording": "Opname",
            "typeSelect": "Select",
            "typeDropdown": "Dropdown",
            "typeDateTime": "Datum & Tijd",
            "labelAmount": "Aantal",
            "fieldSettingsDivider": "Veldinstellingen",
            "fieldOptionsDivider": "Veldopties",
            "labelMultiline": "Meerdere regels",
            "btnAddOption": "Optie toevoegen",
            "conditionNone": "Geen",
            "conditionIsEqual": "Is gelijk aan",
            "conditionOr": "Of",
            "labelCondition": "Voorwaarde",
            "labelField": "Veld",
            "labelFieldValue": "Waarde",
            "fieldConditionDivider": "Veldvoorwaarde",
            "btnAddCondition": "Voorwaarde toevoegen",
            "chipConditionalDisplay": "Zichtbaar wanneer aan de voorwaarden is voldaan",
            "weatherInfoTagLabel": "Weer Info",
            "precipitationTagLabel": "Neerslag",
            "temperatureTagLabel": "Temperatuur",
            "windForceTagLabel": "Windkracht",
            "windDirectionTagLabel": "Windrichting",
            "cloudinessTagLabel": "Bewolking %",
            "summaryInfoTagLabel": "Samenvatting Info",
            "sizingEstimateMaleTagLabel": "Schatting aantal mannetjes",
            "sizingEstimateFemaleTagLabel": "Schatting aantal vrouwtjes",
            "sizingEstimateTagLabel": "Schatting aantal"
        }
    },
    "masterForms": {
        "settingsMasterFormListRoute": {
            "title": "Standaardformulieren"
        },
        "masterFormList": {
            "preciseLocation": {
                "name": "Precieze Locatie",
                "description": "Geef exact aan waar het dier is waargenomen, inclusief eventuele relevante gebouw- of oriëntatiedetails"
            },
            "startVisit": {
                "name": "Startformulier",
                "description": "Registreer de starttijd van het bezoek en documenteer de weersomstandigheden bij aankomst"
            }
        },
        "masterFormRoute": {
            "preciseLocationFormTitle": "Precieze locatieformulier",
            "startVisitFormTitle": "Startformulier"
        }
    },
    "protocol": {
        "timeslotsRelativeTo": {
            "relativeToSunset": "Zonsondergang",
            "relativeToSunrise": "Zonsopgang",
            "relativeToMidnight": "Middernacht"
        },
        "protocolListScreen": {
            "title": "Protocoltemplates",
            "clientTitle": "Klant protocoltemplates",
            "projectTitle": "Project protocollen"
        },
        "protocolCreateScreen": {
            "title": "Nieuw protocoltemplate",
            "projectScopeTitle": "Nieuw protocol",
            "templateLabel": "Kies een template"
        },
        "protocolEditScreen": {
            "title": "Protocoltemplate bewerken",
            "titleNonAdmin": "Protocoltemplate",
            "projectScopeTitle": "Protocol bewerken",
            "projectScopeTitleNonAdmin": "Protocol",
            "visitsTitle": "Bezoekconfiguratie",
            "dangertitle": "Gevarenzone",
            "workerRequirementsTitle": "Werknemer vereisten",
            "researchRequirementsTitle": "Onderzoekseisen"
        },
        "protocolCourseList": {
            "colName": "Naam",
            "colDescription": "Beschrijving",
            "colDelete": "Verwijderen"
        },
        "protocolDeleteButton": {
            "projectScopeBtnDelete": "Verwijder protocol",
            "btnDelete": "Verwijder protocoltemplate"
        },
        "protocolVisitsEditor": {
            "emptyText": "Nog geen bezoek specificatie",
            "conditionsEditorTitle": "Datum instellingen",
            "pricingEditorTitle": "Prijs instellingen",
            "weatherEditorTitle": "Weer instellingen",
            "timeslotEditorTitle": "Tijd instellingen",
            "name": "Naam",
            "description": "Beschrijving",
            "btnAdd": "Bezoek toevoegen",
            "btnDeleteVisit": "Bezoek verwijderen",
            "btnSave": "Opslaan"
        },
        "visitSummary": {
            "timeslots": "Tijdsloten",
            "duration": "Duur",
            "costPerHour": "Kosten/u",
            "name": "Naam",
            "weatherConditions": "Weersomstandigheden",
            "temperature": "Temperatuur",
            "maxWindForce": "Max. windkracht",
            "maxPrecipitation": "Max. neerslag",
            "conditions": "Voorwaarden",
            "copyVisit": "Bezoek kopiëren"
        },
        "protocolVisitsPricingEditor": {
            "labelPricePerHour": "Prijs per uur",
            "labelcalculateTravelCosts": "Bereken reiskosten"
        },
        "protocolVisitsWeatherEditor": {
            "labelTemperature": "Temperatuur",
            "labelMaxWindForce": "Max. windkracht",
            "labelMaxPrecipitation": "Max. neerslag",
            "precipitation": {
                "dry": "Droog",
                "mist": "Mist",
                "drizzle": "Motregen",
                "rain": "Regen",
                "heavyrain": "Zware regen",
                "hail": "Hagel",
                "snow": "Sneeuw"
            }
        },
        "protocolVisitConditionsEditor": {
            "conditionAnd": "En",
            "conditionOr": "Of",
            "conditionMinDate": "Minimale datum",
            "conditionMaxDate": "Maximale datum",
            "conditionAfterVisit": "Na bezoek",
            "conditionBeforeVisit": "Voor bezoek",
            "selectConditionType": "Voorwaarde type",
            "labelMinDate": "Selecteer datum",
            "labelMaxDate": "Selecteer datum",
            "selectVisit": "Bezoek",
            "selectVisitEmpty": "Bezoek",
            "waitDays": "Wachtdagen",
            "btnAddCondition": "Voorwaarde toevoegen"
        },
        "protocolVistsTimeslotsEditor": {
            "titleTimeslots": "Tijdsloten",
            "labelDuration": "Duur",
            "durationSuffix": "uur",
            "durationDescription": "Alleen bezoektijd. Reistijd wordt apart berekend",
            "labelStartRelativeTo": "Start relatief aan",
            "labelStartOffset": "Compensatie",
            "labelEndRelativeTo": "Einde relatief aan",
            "labelEndOffset": "Compensatie",
            "addTimeslot": "Tijdslot toevoegen",
            "availability": "Beschikbaarheid",
            "availabilityRequired": "Vul dit veld in"
        },
        "protocolDataGrid": {
            "headerName": "Naam",
            "headerStartAt": "Start op",
            "filterSearch": "Zoeken op naam"
        },
        "protocolForm": {
            "labelName": "Naam",
            "labelResearchType": "Onderzoekstype",
            "labelDescription": "Beschrijving",
            "labelCollectAllMediaPoints": "Verzamelen media punten",
            "labelCollectAllMediaPointsCollectAll": "Alles verzamelen",
            "labelCollectAllMediaPointsCollectObservationsOnly": "Alleen observatie media verzamelen",
            "labelRequiresRouteShuffling": "Route startposities willekeurig maken",
            "labelRequiresRouteShufflingHelperText": "Deze instelling aanpassen heeft geen impact op bestaande bezoeken",
            "startAt": "Start op",
            "endAt": "Eindigt op",
            "btnSubmit": "Opslaan"
        }
    },
    "shared": {
        "ProjectSelectElement": {
            "selectAll": "Alles selecteren"
        },
        "QuestionAmount": {
            "exactBtn": "exact",
            "estimatedBtn": "geschat"
        },
        "VisitSimplifiedStatusChip": {
            "planned": "Gepland",
            "unplanned": "Niet gepland",
            "approved": "Goedgekeurd",
            "ecoTeamReview": "Eco Team Review"
        },
        "PlannerAreaStatusChip": {
            "confirmed": "Bevestigd",
            "onHold": "Gepauzeerd",
            "cancelled": "Geannuleerd"
        },
        "IsRejectedAlert": {
            "rejected": {
                "actorOnDate": "Afgekeurd door <avatar></avatar> op {{date}}",
                "reason": "Reden"
            },
            "deleted": {
                "actorOnDate": "Verwijderd door <avatar></avatar> op {{date}}",
                "reason": "Reden"
            }
        },
        "VisitStatusChip": {
            "unplanned": "Niet gepland",
            "planned": "Gepland",
            "awaitingReport": "Wachtend op rapportages",
            "awaitingApproval": "Wachtend op goedkeuring",
            "awaitingConfirm": "Wachtend op bevestiging",
            "awaitingObservationApproval": "Wachtend op goedkeuring van observaties",
            "approved": "Goedgekeurd",
            "deleted": "Verwijderd"
        },
        "PlannerShiftCompletionStatusSelect": {
            "label": "Shift status",
            "planned": "Gepland",
            "awaitingReport": "Wachtend op rapportages",
            "awaitingApproval": "Wachtend op goedkeuring",
            "approved": "Goedgekeurd"
        },
        "SpeciesSelect": {
            "typeToSearchLabel": "Typ om te zoeken...",
            "noOptionsFoundLabel": "Geen opties gevonden"
        }
    },
    "common": {
        "validation": {
            "valid": "Geldig",
            "invalid": "Ongeldig",
            "checking": "Validatiestatus controleren..."
        }
    }
}
